import { Credit, Job, Payment } from '@kanda-libs/ks-frontend-services';

import { Provider } from 'pages/Status/context';

import { getAlliumState } from '../Content/Lenders/Allium/helpers';
import { getDemoState } from '../Content/Lenders/Demo/helpers';
import { getEtikaState } from '../Content/Lenders/Etika/helpers';
import { getHummState } from '../Content/Lenders/Humm/helpers';
import { getNovunaState } from '../Content/Lenders/Novuna/helpers';
import { getOmniState } from '../Content/Lenders/Omni/helpers';
import { getPropensioState } from '../Content/Lenders/Propensio/helpers';
import { LenderStatus } from '../Content/Lenders/constants';

export const getLenderStatus = (
  job: Job | undefined,
  credit: Credit | undefined,
  provider: Provider | undefined,
  deposit: Payment | undefined,
  isFinanced: boolean,
  isLoading: boolean,
): LenderStatus => {
  if (!job || isLoading) return 'loading';
  if (job && !isFinanced) return 'referred';
  if (!credit || !provider || !isFinanced) return 'referred';
  if (provider === 'allium') return getAlliumState(job, credit, deposit);
  if (provider === 'propensio') return getPropensioState(job, credit, deposit);
  if (provider === 'humm') return getHummState(job, credit, deposit);
  if (provider === 'omni') return getOmniState(job, credit, deposit);
  if (provider === 'novuna') return getNovunaState(job, credit, deposit);
  if (provider === 'etika') return getEtikaState(job, credit, deposit);
  return getDemoState(job, credit, deposit);
};

export const getInAwaitDecision = (lenderStatus: LenderStatus): boolean =>
  [
    'loading',
    'under_review',
    'action_required',
    'referred',
    'pending',
  ].includes(lenderStatus);

export const getInCompletePurchase = (lenderStatus: LenderStatus): boolean =>
  ['sign_documents', 'deposit', 'accepted'].includes(lenderStatus);

export const getInCompleteJob = (lenderStatus: LenderStatus): boolean =>
  ['ready_to_start'].includes(lenderStatus);

export const getInSatNote = (lenderStatus: LenderStatus): boolean =>
  ['sat_note_delayed', 'sat_note'].includes(lenderStatus);

export const getInFinished = (lenderStatus: LenderStatus): boolean =>
  ['lender_review', 'finished'].includes(lenderStatus);

export const getInNotApproved = (lenderStatus: LenderStatus): boolean =>
  ['cancelled', 'declined', 'not_approved'].includes(lenderStatus);
